<template>
    <div>
        <vs-row>
            <vs-col>
                <p class="h4 mt-5">{{ title }}</p>
            </vs-col>
        </vs-row>
        <vs-row>
            <vs-col>
                <vs-table
                    :sst="true"
                    @search="eventSearchItems"
                    @sort="eventSortByCol"
                    search
                    :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
                    style="width:100%"
                    :data="itemsData"
                >
                    <template slot="thead">
                        <vs-th width="100"></vs-th>
                        <vs-th>
                            <Sort name="employee,last_name" @sort="eventSortByCol" :value="apiParams.sortBy['employee,last_name']">Nom</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="employee,first_name" @sort="eventSortByCol" :value="apiParams.sortBy['employee,first_name']">Prénom</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="establishments,name" @sort="eventSortByCol">Établissements</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="services,title" @sort="eventSortByCol">Services</Sort>
                        </vs-th>
                        <vs-th v-if="evaluation">
                            <Sort name="eval_type" @sort="eventSortByCol">Type d'eval.</Sort>
                        </vs-th>
                        <vs-th>
                            <Sort name="rating_date" @sort="eventSortByCol">Date {{ typeName === 'transmission' ? 'de' : 'du' }} {{ typeName }}</Sort>
                        </vs-th>
                        <vs-th v-if="!hideCreator">
                            <Sort name="created_at" @sort="eventSortByCol">Créé le</Sort>
                        </vs-th>
                        <vs-th v-if="!hideCreator">
                            <Sort name="created_by" @sort="eventSortByCol">Créé par</Sort>
                        </vs-th>
                        <vs-th></vs-th>
                    </template>

                    <template>
                        <vs-tr v-for="(item, i) in itemsData" :key="i">
                            <vs-td>
                                <vs-avatar
                                    v-if="get(item, ':photoUrl')"
                                    size="70px"
                                    :src="get(item, ':photoUrl')"
                                />
                                <vs-avatar
                                    v-else
                                    size="70px"
                                    :color="generateColor(item.name)"
                                />
                            </vs-td>
                            <vs-td>
                                <a :href="`/rh/gestion/personnes/${item.employee.id}/bilans`" style="color: rgb(98, 98, 98)">
                                    <b>{{ get(item, ":employee.last_name") }}</b>
                                </a>
                            </vs-td>
                            <vs-td>
                                <a :href="`/rh/gestion/personnes/${item.employee.id}/bilans`" style="color: rgb(98, 98, 98)">
                                    <b>{{ get(item, ":employee.first_name") }}</b>
                                </a>
                            </vs-td>
                            <vs-td>
                                {{ arrayUnique(get(item, ":employee.services").map(s => s.establishment.name)).join(', ') }}
                            </vs-td>
                            <vs-td>
                                {{ arrayUnique(get(item, ":employee.services").map(s => s.title)).join(', ') }}
                            </vs-td>
                            <vs-td v-if="evaluation">
                                {{ get(item, ":eval_type") }}
                            </vs-td>
                            <vs-td>
                                {{ formatDateFr(get(item, ":rating_date")) }}
                            </vs-td>
                            <vs-td v-if="!hideCreator">
                                {{ formatDateFr(get(item, ":created_at")) }}
                            </vs-td>
                            <vs-td v-if="!hideCreator">
                                {{ get(item, ":creator.name") }}
                            </vs-td>
                            <vs-td class="action">
                                <div class="action-wrapper">
                                    <template v-if="action && action.length > 0">
                                        <template v-for="(button, i) in action">
                                            <template v-if="dynamik(item, button.permission)">
                                                <vs-button
                                                    :id="button.id ? dynamik(item, button.id) : null"
                                                    :href="dynamik(item, button.href)"
                                                    class="vs-con-loading__container"
                                                    v-tooltip="button.tooltip"
                                                    color="primary"
                                                    type="border"
                                                    icon-pack="feather"
                                                    :icon="button.icon"
                                                    v-on="button.on ? dynamik(item, button.on) : null"
                                                />
                                            </template>
                                        </template>
                                    </template>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>

                <vs-row>
                    <vs-col class="mt-4" v-if="items.total > 0">
                        <vs-pagination
                            :total="Math.ceil(items.total / apiParams.perpage)"
                            v-model="currentPage"
                        ></vs-pagination>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import {formatDate} from '@assets/utils/helpers/helpers.js'

export default {
    name: "RatingsInProgress",
    props: {
        api: {
            type: String,
            required: true
        },
        typeName: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        filter: {
            type: String,
            required: true
        },
        action: {
            type: Array,
        },
        hideCreator: {
            type: Boolean,
            default: false
        },
        evaluation: {
            type: Boolean,
            default: false
        },
        forceLoading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            log: console.log,
            formatDateFr: formatDate,
            currentPage: 1,
            loading: false,
        }
    },
    watch: {
        forceLoading(value) {
            this.loading = value;
        },
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        dynamik(item, callback) {
            return callback(item)
        }
    },
    created() {
        this.apiParams.include = [
            'employee.services.establishment',
            'creator'
        ];
        this.apiParams.perpage = 5;
        this.apiParams.filter = this.filter
        this.apiParams.sortBy = {'employee,last_name': 'desc'}
        this.loadItems();
    }
};
</script>

<style scoped>
.vs-table--thead > tr {
    background-color: #999;
}
</style>
